import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import "./App.css";
import MigrationNotice from "./migrationNotice";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Route path="/" component={MigrationNotice} />
      </BrowserRouter>
    </div>
  );
}

export default App;
